const TradingCalculatorContentTwo = () => {
  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="row reverse-mobile">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="thumb-left">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/resources/trading_calculator/trading_calculator_2.png"
                }
                alt="computer images"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <h2>How to Use The Pips Trading Calculator</h2>
              <p>
                Simply select your account type, instrument, lot size, and
                leverage to get instant results. The calculator automatically
                provides key metrics such as margin requirement, pip value, swap
                rate, and potential profit or loss, giving you the insights you
                need before entering a trade. By visualizing your risk and
                potential reward, The Pips Trading Calculator helps you trade
                strategically, plan position sizes responsibly, and manage your
                capital effectively. It eliminates guesswork by presenting all
                essential numbers in a clear, easy-to-understand format. You can
                compare different scenarios in seconds, helping you choose the
                most efficient and risk-aligned approach. Whether you're a
                beginner or an experienced trader, it ensures every trade starts
                with accurate, reliable calculations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradingCalculatorContentTwo;
